import { useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useUIStateStore } from "@/store/uiStateStore";

// import AppState from "../store/appstate";
import useAppStore from "../store/appStateZustand";
import H2 from "./H3";
import LoadingSmall from "./LoadingSmall";
import Spacer from "./Spacer";

function ChangeAccountModal({
  accounts,
  to,
  account,
  setSwitchModal,
}) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const isTunecore = useUIStateStore(state => state.isTunecore);
  const setSelectedAccount = useAppStore(s => s.setSelectedAccount);
  const setSelectedCatalogue = useAppStore(s => s.setSelectedCatalogue);

  useEffect(() => {
    setSelectedAccount(account.artistAccountCode ?? account.artistaccountcode);
    setSelectedCatalogue(account.catalogueCode ?? account.cataloguecode);

    if (accounts.length === 1) {
      setSwitchModal(null);
      navigate({ to });
      return;
    }

    const timer = setTimeout(() => {
      setSwitchModal(null);
      navigate({ to });
    }, 2000);

    return () => clearTimeout(timer);
  }, [account.artistAccountCode, account.artistaccountcode, account.catalogueCode, account.cataloguecode, accounts.length, navigate, setSwitchModal, to, setSelectedAccount, setSelectedCatalogue]);

  if (accounts.length === 1)
    return <></>;

  return (
    <div className="fixed top-0 left-0 z-40 flex items-center justify-center w-screen h-screen bg-black bg-opacity-50">
      <div className={`${isTunecore ? "bg-tunecore-dark-element" : "bg-white"} rounded-lg relative lg:w-1/3 w-7/8 p-8 flex items-center justify-center flex-col text-center`}>
        <LoadingSmall />
        <Spacer />
        <H2>
          {t("auth:switching-account")}
          {" "}
          <br />
          {account.name}
        </H2>
      </div>
    </div>

  );
}

export default ChangeAccountModal;
